//= include plugins/nouislider.js
//= include plugins/popper.js
//= include plugins/tippy.js
//= include plugins/fancybox.js
//= include plugins/owl.carousel.js

//= include parts/nav.js
//= include parts/togglepassword.js
//= include parts/count.js
//= include parts/wishlist.js

$(document).ready(function () {
    if ($('.productsCarousel').length) {
        $('.productsCarousel').owlCarousel({
            loop: false,
            margin: -1,
            navText: [
                '<svg width="24" height="24"><use href="/public/dist/svg/defs.svg#chevron_left"></use></svg>',
                '<svg width="24" height="24"><use href="/public/dist/svg/defs.svg#chevron_right"></use></svg>',
            ],
            responsive: {
                0: {
                    nav: false,
                    dots: true,
                    items: 2,
                    slideBy: 2,
                },
                960: {
                    nav: true,
                    dots: false,
                    items: 3,
                    slideBy: 3,
                },
                1280: {
                    nav: true,
                    dots: false,
                    items: 4,
                    slideBy: 4,
                },
            },
        })
    }

    if ($('.bannerCarousel').length) {
        $('.bannerCarousel').owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            items: 1,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
        })
    }

    if ($('.galleryCarousel').length) {
        $('.galleryCarousel').owlCarousel({
            loop: false,
            margin: 0,
            nav: false,
            dots: true,
            responsive: {
                0: {
                    items: 3,
                },
                960: {
                    items: 4,
                },
                1280: {
                    items: 5,
                },
            },
        })
    }

    $('.owl-carousel').each(function () {
        //Find each set of dots in this carousel
        $(this)
            .find('.owl-dot')
            .each(function (index) {
                //Add one to index so it starts from 1
                $(this).attr('aria-label', index + 1)
            })
    })

    /* Popup banner - small */
    let popupBanner = $('#popup');
    if (popupBanner.length) {
        $('.popup__close', popupBanner).on('click', function() {
            CookieService.createCookie('hideRightBanner', 1, 0, 2);
            popupBanner.remove();
        });
        if(!popupBanner.hasClass('popup--dontClose')){
            $(popupBanner).on('click', function() {
                CookieService.createCookie('hideRightBanner', 1, 0, 2);
                popupBanner.remove();
            });
        }
    }

    tippy('[data-tippy-content]')

    Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        Toolbar: {
            display: {
                left: ['infobar'],
                middle: [],
                right: ['close'],
            },
        },
    });
})
